import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  makeStyles,
  Paper,
} from "@material-ui/core";
import { Warning } from "@material-ui/icons";
import { useTranslation } from "../hooks/useTranslation";
import { useAuth } from "../context/ApiKeyContext";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: "12px",
      minWidth: "400px",
    },
  },
  dialogTitle: {
    backgroundColor: "var(--ikaro-orange-primary)",
    color: "var(--ikaro-text-white)",
    padding: theme.spacing(2),
    "& .MuiTypography-h6": {
      fontWeight: "bold",
      fontSize: "1.1rem",
    },
  },
  dialogContent: {
    padding: theme.spacing(3),
    textAlign: "center",
  },
  warningIcon: {
    fontSize: "3rem",
    color: "var(--ikaro-orange-primary)",
    marginBottom: theme.spacing(2),
  },
  cellInfo: {
    backgroundColor: "var(--ikaro-gray-light)",
    padding: theme.spacing(2),
    borderRadius: "8px",
    margin: theme.spacing(2, 0),
    border: "1px solid var(--ikaro-gray-medium)",
  },
  cellName: {
    fontWeight: "bold",
    color: "var(--ikaro-gray-darker)",
    fontSize: "1.1rem",
  },
  confirmationText: {
    color: "var(--ikaro-gray-dark)",
    marginBottom: theme.spacing(2),
    fontSize: "1rem",
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    justifyContent: "center",
    gap: theme.spacing(2),
  },
  cancelButton: {
    color: "var(--ikaro-gray-dark)",
    borderColor: "var(--ikaro-gray-medium)",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "var(--ikaro-gray-light)",
    },
  },
  confirmButton: {
    backgroundColor: "var(--ikaro-orange-primary)",
    color: "var(--ikaro-text-white)",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "var(--ikaro-orange-hover)",
    },
  },
}));

const CellConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  cellName,
  jobType = "tarefa",
}) => {
  const classes = useStyles();
  const { t } = useTranslation("common");
  const { cell } = useAuth();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const displayCellName = cellName || cell?.title || "Célula não selecionada";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.dialog}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle className={classes.dialogTitle}>
        <Box display="flex" alignItems="center">
          <Warning style={{ marginRight: "8px" }} />
          {t("cellConfirmation.title")}
        </Box>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <Warning className={classes.warningIcon} />

        <Typography className={classes.confirmationText}>
          {t("cellConfirmation.message", {
            cellName: displayCellName,
            jobType,
          })}
        </Typography>

        <Paper className={classes.cellInfo}>
          <Typography variant="body2" color="textSecondary">
            {t("cellConfirmation.currentCell")}
          </Typography>
          <Typography className={classes.cellName}>
            {displayCellName}
          </Typography>
        </Paper>

        <Typography variant="body2" color="textSecondary">
          {t("cellConfirmation.continueMessage")}
        </Typography>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={onClose}
          variant="outlined"
          className={classes.cancelButton}
        >
          {t("cellConfirmation.cancel")}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          className={classes.confirmButton}
        >
          {t("cellConfirmation.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CellConfirmationModal;
